import { useAtom } from 'jotai'
import { useResetAtom } from 'jotai/utils'

import {
  listAtom,
  listFilterAtom,
  listFilterTrxAtom,
  listFilterMarketingAtom,
  memberDetailAtom,
  memberDetailTabAtom,
  tabNameAtom,
} from '../store'

export const useMember = () => {
  const [list, listSet] = useAtom(listAtom)
  const [listFilter, listFilterSet] = useAtom(listFilterAtom)
  const resetListFilter = useResetAtom(listFilterAtom)
  const [listFilterTrx, listFilterSetTrx] = useAtom(listFilterTrxAtom)
  const resetListFilterTrx = useResetAtom(listFilterTrxAtom)
  const [listFilterMarketing, listFilterSetMarketing] = useAtom(listFilterMarketingAtom)
  const resetListFilterMarketing = useResetAtom(listFilterMarketingAtom)

  const [tabName, tabNameSet] = useAtom(tabNameAtom)

  const [detail, detailSet] = useAtom(memberDetailAtom)
  const [detailTab, detailTabSet] = useAtom(memberDetailTabAtom)

  const updateDetail = (
    data: any,
    type:
      | 'Segment'
      | 'Address'
      | 'Consent'
      | 'Transaction'
      | 'Engagement'
      | 'SmsEngagement'
      | 'PushEngagement'
      | 'EmailEngagement'
  ) => {
    detailTabSet((prev) => {
      // if (!prev) return null

      return {
        ...prev,
        [type]: data,
      }
    })
  }

  return {
    list,
    listSet,
    detail,
    detailSet,
    tabName,
    tabNameSet,
    detailTab,
    detailTabSet,
    updateDetail,
    listFilter,
    listFilterSet,
    resetListFilter,
    listFilterTrx,
    listFilterSetTrx,
    resetListFilterTrx,
    listFilterMarketing,
    listFilterSetMarketing,
    resetListFilterMarketing,
  }
}